module.exports = __webpack_public_path__ + "img/logo.9aad89b6.png";